/* eslint-disable padding-line-between-statements */
import React, { useCallback, useContext,useState, useEffect, useMemo } from 'react';
import { ModalBody, ModalFooter, ModalHeader, ModalNext } from '@jutro/components';
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { TWIAStandardizeButton, TWIAStandardizationStatus } from 'twia-capability-address-component';
import metadata from './AdditionalInsuredDetails.metadata.json5';
import messages from '../Insureds.messages';
import StandardAddressValidationUtil from '../../../util/StandardAddressValidationUtil';
import addressControl from '../../../util/addressControl';

import { Button, CheckboxField, Radio, RadioField } from '@jutro/legacy/components';

function AdditionalInsuredDetails(props) {

    const {
        newAdditionalInsured, updatePolicyAddressVM,
        authHeader,
        showInsured,
        saveData, cancelData, isInvalid, isUpdated, showErrors
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const [displayError, setDisplayError] = useState(false);
    const [modalItem, updateModalItem] = useState(newAdditionalInsured);
    const [zipcodeValidationMessage, setZIPCodeValidationMessage] = useState([]);
    const isUSZIPCode = (code) => /^[0-9]{5}(?:-[0-9]{4})?$/.test(code);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('AdditionalInsuredDetails');
    const [primaryAddressVM, setPrimaryAddressVM] = useState(modalItem.accountContactDTO.primaryAddress);
    const [showAddressValidationStatus, setStatus] = useState(false);
    const [ pcConstants, setPCConstants ] = useState([]);
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [addInsuredButton, setAddInsuredButton] = useState(false); // DE16635
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false); //DE16671
    const [noMatchFound, setNoMatchFound] = useState(false);
    const xPortal = 'PE';
    
    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, []);

    useEffect(() => {
        const val = primaryAddressVM?.value || primaryAddressVM; //DE17215
        setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
    },[primaryAddressVM]);
    
    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value.value, xPortal))
            setAddInsuredButton(true);
        }
    }, [])

    const breakpoint = useContext(BreakpointTrackerContext);
    const errorHandling = useCallback(() => {
        if(!displayError) { setDisplayError(true) }
    }, [displayError] );
    
    useEffect(() => {
        setStatus(addressControl.showStatus(primaryAddressVM.value, xPortal)); //DE16004
        getPCConstants();
    }, [getPCConstants, primaryAddressVM]);
    
    const updatePrimaryAddressVM = useCallback((value) => {
        _.set(modalItem.value, 'accountContactDTO.primaryAddress', value);
        updateModalItem(modalItem);
        setPrimaryAddressVM(modalItem.accountContactDTO.primaryAddress);
        updatePolicyAddressVM(value);
        setIsAddressEdited(false); //DE16671
        setDisablity(value);
    }, [modalItem, setDisablity, updatePolicyAddressVM]);
    
    const validateZIPCode = useCallback(
        (value, path) => {
            _.set(modalItem, path, value);
            setZIPCodeValidationMessage([]);

            if (!value) {
                setZIPCodeValidationMessage([translator(messages.required)])
            } else if (!isUSZIPCode(value)) {
                setZIPCodeValidationMessage([translator(messages.ZIPCodeValidationMessage)])
            }
            updateModalItem(modalItem);
            refreshData();
        },
        [modalItem, refreshData, translator]);
    
    const writeValue = useCallback(
        (value, path) => {
            if (path === 'accountContactDTO.primaryAddress.addressLine1'
                || path === 'accountContactDTO.primaryAddress.addressLine2'
                || path === 'accountContactDTO.primaryAddress.city'
                || path === 'accountContactDTO.primaryAddress.state'
                || path === 'accountContactDTO.primaryAddress.county'
                ||path === 'accountContactDTO.primaryAddress.postalCode')
            {
                StandardAddressValidationUtil.setNotValidated(primaryAddressVM.value);
                setStatus(addressControl.showStatus(primaryAddressVM.value, xPortal));
                setPrimaryAddressVM(modalItem.accountContactDTO.primaryAddress);
                setIsAddressEdited(true); //DE16671
            }
            _.set(modalItem, path, value);
            updateModalItem(modalItem);
            setPrimaryAddressVM(modalItem.accountContactDTO.primaryAddress);
            refreshData();
        }, [modalItem, primaryAddressVM, refreshData]
    );

    const handleStandardizationResponse =useCallback((value)=> {
        const val = primaryAddressVM?.value || primaryAddressVM; //DE17215
        if(xPortal === 'CC'){
            setNoMatchFound(val.addressStandResult?.noAddressMatchFound);
        } else {
            setNoMatchFound(value.noAddressMatchFound);
        }
    });
    
    const onSave = () => {
        if(!isComponentValid) {
            errorHandling();
            isInvalid(isComponentValid, 'AdditionalInsuredDetails');
        } else {
            saveData(modalItem);
            setIsAddressEdited(false);
        }
    };

    const onCancel = () => {
        setDisplayError(false);
        isInvalid(true, 'AdditionalInsuredCoveragePopup');
        cancelData();
        // onResolve();
    }
    
    const relationToInsuredOptions = [
        {code: 'Parent', name: 'Parent'},
        {code: 'Child', name: 'Child'},
        {code: 'Grandparent', name: 'Grandparent'},
        {code: 'Grandchild', name: 'Grandchild'},
        {code: 'Heir', name: 'Heir'},
        {code: 'Trustee', name: 'Trustee'},
        {code: 'Beneficiary', name: 'Beneficiary'},
        {code: 'Executor', name: 'Executor'},
        {code: 'Other', name: 'Other'}
    ];
    
    const ContactTypeOptions = [
        {
            code: 'Company',
            name: 'Estate/Trust'
        },
        {
            code: 'Person',
            name: 'Person'
        }
    ];

    const resolvers = {
        resolveCallbackMap: {
            OnValidateZIPCode: validateZIPCode,
        },
        resolveComponentMap: {
            standardizeButtonComponent: TWIAStandardizeButton,
            standardizeStatusComponent: TWIAStandardizationStatus
        },
    }
    
    const contactType = _.get(modalItem, 'accountContactDTO.subtype.value');

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        occupancyType: {
            availableValues: ContactTypeOptions
        },
        relation: {
            availableValues: relationToInsuredOptions
        },
        firstName: {
            visible: contactType === 'Person',
            required: contactType === 'Person',
            showRequired: contactType === 'Person',
        },
        lastName: {
            visible: contactType === 'Person',
            required: contactType === 'Person',
            showRequired: contactType === 'Person',
        },
        company: {
            visible: contactType === 'Company',
            required: contactType === 'Company',
            showRequired: contactType === 'Company',
        },
        zipCode: {
            validationMessages: zipcodeValidationMessage
        },
        cancelButtonId: {
            onClick: onCancel
        },
        saveButtonId: {
            onClick: onSave,
            disabled: isComponentValid === false || !addInsuredButton || isAddressEdited, //DE16671
            content: _.get(newAdditionalInsured,'fixedId.value')!==undefined ? { // DE16557
                        id: "tfpa.gateway.contacts.AddInsured",
                        defaultMessage: "Update Insured"
                    } : {
                        id: "tfpa.gateway.contacts.AddInsured",
                        defaultMessage: "Add Insured"
                    }
        },
        statusComponent: {
            primaryAddressVM: primaryAddressVM.value, status:showAddressValidationStatus,
            isStandardizationDisabled,
            visible: showAddressValidationStatus,
            noMatchFound
        },
        buttonComponent: {
            primaryAddressVM: primaryAddressVM.value, 
            updatePrimaryAddressVM,
            authHeader, isStandardizationDisabled,
            standardizationResponse: handleStandardizationResponse,
            xPortal,
            zipCodevalidationMsg: zipcodeValidationMessage
        },
    }

    return (
        <ViewModelForm
                    uiProps={metadata.pageContent} 
                    overrideProps={overrideProps}
                    model={modalItem}
                    showErrors={showErrors || displayError}
                    onValueChange={writeValue}
                    onValidationChange={setComponentValidation}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default AdditionalInsuredDetails